import React from "react";
import "./UniversalFooter.scss";

const UniversalFooter: React.FC = () => {
  return (
    <div className="universalfooter aem-GridColumn aem-GridColumn--default--12">
      <div id="footerArea" className="uhf">
        <div id="footerRegion">
          <div id="footerUniversalFooter">
            <footer id="uhf-footer" className="c-uhff context-uhf">
              <nav className="c-uhff-nav">

                {/* Row 1 — 3 columns: only routes that exist in CHome */}
                <div className="c-uhff-nav-row">

                  <div className="c-uhff-nav-group">
                    <div className="c-heading-4">Products</div>
                    <ul className="c-list f-bare">
                      <li><a className="c-uhff-link" href="/crm">CRM</a></li>
                      <li><a className="c-uhff-link" href="/accounting">Accounting</a></li>
                      <li><a className="c-uhff-link" href="/email-&-calendars">Email &amp; Calendars</a></li>
                      <li><a className="c-uhff-link" href="/swiftgrid-email-api">Swift Grid Email API</a></li>
                      <li><a className="c-uhff-link" href="/hospitality-&-pms">Hospitality &amp; PMS</a></li>
                      <li><a className="c-uhff-link" href="/academic-portals">Academic Portals</a></li>
                      <li><a className="c-uhff-link" href="/Artificial-Intelligence">Artificial Intelligence</a></li>
                    </ul>
                  </div>

                  <div className="c-uhff-nav-group">
                    <div className="c-heading-4">Industries</div>
                    <ul className="c-list f-bare">
                      <li><a className="c-uhff-link" href="/Industries">All Industries</a></li>
                      <li><a className="c-uhff-link" href="/hospitality-&-pms">Hospitality</a></li>
                      <li><a className="c-uhff-link" href="/academic-portals">Education</a></li>
                    </ul>
                  </div>

                  <div className="c-uhff-nav-group">
                    <div className="c-heading-4">Company</div>
                    <ul className="c-list f-bare">
                      <li><a className="c-uhff-link" href="/About">About Cilpron</a></li>
                      <li><a className="c-uhff-link" href="/contact">Contact Us</a></li>
                    </ul>
                  </div>

                </div>
                {/* clearfix so floats don't bleed into base */}
                <div style={{ clear: "both" }} />

              </nav>

              <div className="c-uhff-base">
                <a
                  id="locale-picker-link"
                  className="c-uhff-link c-uhff-lang-selector c-glyph glyph-world"
                  href=""
                >
                  English (Nigeria)
                </a>

                <nav>
                  <ul className="c-list f-bare">
                    <li id="c-uhff-footer_contactus">
                      <a className="c-uhff-link" href="/contact">Contact Cilpron</a>
                    </li>
                    <li>© Cilpron {new Date().getFullYear()}</li>
                  </ul>
                </nav>
              </div>

            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniversalFooter;